export default __webpack_public_path__ + "static/media/sf_ui_display_regular.2a83d664.ttf";